/* “Proven in the field” — lay the three case studies out as equal
   cards under a full-width heading instead of a narrow stacked column. */
(function () {
  function styles() {
    if (document.getElementById("bsl-cases-style")) return;
    var s = document.createElement("style");
    s.id = "bsl-cases-style";
    s.textContent = [
      /* heading row goes full width */
      ".bsl-cases-wrap{grid-template-columns:1fr !important;gap:2.5rem !important;" +
        "padding-top:4rem !important;padding-bottom:4rem !important}",
      /* the three cards, equal size */
      ".bsl-cases-grid{display:grid !important;grid-template-columns:repeat(3,minmax(0,1fr)) !important;" +
        "gap:1.25rem !important;align-items:stretch !important;margin-top:0 !important}",
      ".bsl-cases-grid > *{margin:0 !important}",
      "@media(max-width:1000px){.bsl-cases-grid{grid-template-columns:repeat(2,minmax(0,1fr)) !important}}",
      "@media(max-width:640px){.bsl-cases-grid{grid-template-columns:1fr !important}}",
      /* equalise the cards themselves */
      ".bsl-cases-grid article{height:100% !important;display:flex !important;flex-direction:column !important;" +
        "min-height:420px;border:1px solid rgba(245,168,0,.16);border-radius:14px;overflow:hidden}",
      ".bsl-cases-grid article > div:last-child{flex:1;display:flex;flex-direction:column}",
      ".bsl-cases-grid article p{flex:0 0 auto}",
      /* stats sit at the bottom of every card so they line up */
      ".bsl-cases-grid article dl,.bsl-cases-grid article .mt-auto{margin-top:auto !important}"
    ].join("");
    document.head.appendChild(s);
  }

  function build() {
    styles();
    var hs = document.querySelectorAll("h2"), sec = null;
    for (var i = 0; i < hs.length; i++) {
      if (/proven in the field/i.test(hs[i].textContent)) {
        sec = hs[i].closest("section") || hs[i].parentElement;
        break;
      }
    }
    if (!sec || sec.dataset.bslCases) return;

    var arts = sec.querySelectorAll("article");
    if (arts.length < 2) return;

    /* the element that directly holds the cards */
    var holder = arts[0].parentElement;
    if (!holder) return;
    holder.classList.add("bsl-cases-grid");
    holder.classList.remove("space-y-8", "mt-10");

    /* the two-column wrapper above it — make it a single stacked column */
    var wrap = holder.closest("div.grid") || holder.parentElement;
    while (wrap && wrap !== sec && getComputedStyle(wrap).display !== "grid") {
      wrap = wrap.parentElement;
    }
    if (wrap && wrap !== sec) wrap.classList.add("bsl-cases-wrap");

    /* if the cards sit inside a column div, lift them up a level so the
       grid spans the full width */
    if (holder.parentElement && holder.parentElement !== wrap && wrap) {
      var col = holder.parentElement;
      if (col.children.length === 1 && wrap.contains(col)) {
        wrap.appendChild(holder);
        if (!col.children.length) col.remove();
      }
    }

    sec.dataset.bslCases = "1";
  }

  new MutationObserver(build).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") build();
  else document.addEventListener("DOMContentLoaded", build);
  window.addEventListener("load", build);
})();
